// extracted by mini-css-extract-plugin
module.exports = {"canvas":"barcode_canvas__qBLbi"};